import { Card, CircularProgress } from '@material-ui/core';
import {
  Button,
  Grid
} from "@mui/material";
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { toast } from 'react-toastify';
import belsoft_logo from "../../assets/images/iconround.png";
import { useNavigate } from "react-router-dom";
import ParameterConstants from '../../constants/ParameterConstants';
import belsoftCore from '../../core/index.ts';


export default function CustomLogin() {

  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [numberOfPasswordEntry, setNumberOfPasswordEntry] = useState(5)
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true)

    if (username === "" || password === "") {
      alert("Lütfen Kullanıcı adı ve şifre alanını boş bırakmayınız");
      setLoading(false)
    } else {
      try {
        const USER_INFO = await belsoftCore.services.tapuService.validateUser(username, password);
        if (typeof (USER_INFO) === "string") {
          //ShowExceptionMessage("Hata", USER_INFO)
          setLoading(false)
          return;
        }
        if (USER_INFO !== null) {
          const detailedUserInfo = await belsoftCore.services.tapuService.getUserInfo(USER_INFO.UserCode)
          if (!detailedUserInfo.IsLockedOut) {
            setLoading(false)
            sessionStorage.setItem("userInfo", JSON.stringify(USER_INFO));
            sessionStorage.setItem("userName", username);

            if (detailedUserInfo.CanBeChangeThePassword) {
            } else {
              navigate(ParameterConstants.URL_EXTENSION)
            }

          } else {
            setLoading(false)
            toast.warning("Kullanıcınız kilitlenmiş lütfen şifrenizi sıfırlayınız.")
          }
        } else {
          if (numberOfPasswordEntry > 0) {
            setNumberOfPasswordEntry(numberOfPasswordEntry - 1)
            setLoading(false)
            toast.warning("Hatalı Giriş", "Kullanıcı adı ve şifrenizi kontrol ediniz");
          } else {
            toast.warning("Maksimum hatalı giriş", "Maksimum hatalı giriş sayınız dolmuştur Lütfen bilgi işlem ile iletişime geçiniz!!");
            setLoading(false)
          }
        }
      } catch (e) {
        setLoading(false);
        toast.warning("Servis hatası", "Lütfen sayfayı yeniden başlatıp tekrar deneyin.");
        return;
      }
    }
  }

  return (
    <div style={{ width: '100%', flex: 1, background: '#1A2038' }} className="h-screen" >
      <Card style={{ width: '36%', position: 'absolute', left: '32%', top: '32%', borderRadius: 12, padding: "30px 30px 20px 30px" }}>
        <Grid container>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <div className="p-8 flex justify-center items-center h-full">
              <img
                style={{ margin: 'auto', height: '10vw' }}
                src={belsoft_logo}
                alt=""
              />
            </div>
          </Grid>
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <ValidatorForm onSubmit={() => { }} /*onSubmit={handleFormSubmit} */>
              <TextValidator
                style={{ width: '70%', marginTop: '10%', marginLeft: "8%" }}
                className="mb-6 w-full"
                variant="outlined"
                size="small"
                label="Kullanıcı Adı"
                onChange={(e) => setUsername(e.target.value)}
                type="text"
                name="username"
              />
              <TextValidator
                style={{ marginTop: '3%', width: '70%', marginLeft: "8%" }}
                className="mb-3 w-full"
                label="Şifre"
                variant="outlined"
                size="small"
                onChange={(e) => setPassword(e.target.value)}
                name="password"
                type="password"
                errorMessages={['Bu alan zorunlu']}
              />


              <div style={{ marginTop: '5%', position: "relative" }}>
                <Button style={{ width: '70%', marginLeft: "8%" }} variant="contained" color="primary" type="submit" onClick={() => handleLogin()}> Giriş </Button>

                {loading && (
                  <CircularProgress
                    size={24}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: -12,
                      marginLeft: -12,
                    }}
                  />
                )}
              </div>

              <div >
                <div className="relative">
                  <span className="text-primary" style={{ textTransform: 'none', color: '#aeaeae', fontSize: 12, marginLeft: "25%" }}>  Kalan Şifre Hakkınız : </span>
                </div>
                <Button style={{ textTransform: 'none', marginLeft: "18%" }}>  Şifrenizi mi Unuttunuz ? </Button>
              </div>

            </ValidatorForm>
          </Grid>
        </Grid>
      </Card>
    </div>
  )
}
